import { DataTable, type Pagination } from '@/components/common/table';
import { useCampuses } from '@/store/org/hooks';
import { type ActionKey, makeColumns } from './columns';
import { useMemo, useState } from 'react';
import { useDisclosure } from '@heroui/react';
import { CampusModal } from './modal';
import type { Campus } from '@/shared/types/campus';

export function Locations() {
  const { loading, list } = useCampuses(false);
  const items = useMemo(
    () => list.filter((item) => !item.data.archived),
    [list],
  );
  const [editing, setEditing] = useState({ id: '', data: {} } as Campus);
  const onAction = (item: Campus, key: ActionKey) => {
    if (key === 'edit') {
      setEditing(item);
      modal.onOpen();
    }
  };

  const modal = useDisclosure();
  const columns = makeColumns(onAction);
  const [page, setPage] = useState(1);
  const pagination: Pagination = {
    enabled: true,
    absolute: true,
    itemsPerPage: 20,
    page,
    onPageChange: (page: number) => setPage(page),
  };

  return (
    <>
      <DataTable
        aria-label='Locations'
        columns={columns}
        items={items}
        loading={loading}
        className='text-gray-800'
        empty={{ icon: 'mdi-location' }}
        pagination={pagination}
      />
      <CampusModal disclosure={modal} item={editing} />
    </>
  );
}
